import SearchIcon from '@pkgs/components/assets/icons/small/Search.svg';
import { type ButtonVariant, Button } from '@ev-tech/ui-core-components/Button';

export const SearchGlobalButton = ({
  buttonRef,
  shouldShowIcon,
  onClick,
  dataTestId,
  buttonLabel,
  variant,
}: {
  buttonRef: React.RefObject<HTMLButtonElement>;
  shouldShowIcon: boolean;
  onClick: () => void;
  dataTestId?: string;
  buttonLabel: string;
  variant?: ButtonVariant;
}) => {
  return (
    <Button
      ref={buttonRef}
      label={buttonLabel}
      icon={shouldShowIcon ? <SearchIcon /> : undefined}
      iconPosition={shouldShowIcon ? 'left' : undefined}
      variant={variant}
      onClick={onClick}
      testId={dataTestId}
    />
  );
};
